import { DatePicker, Button } from "antd";
import {
  SearchOutlined,
  DownloadOutlined,
  LoadingOutlined,
} from "@ant-design/icons";

export function VerticalDateFilter({
  startDateSelection,
  setStartDateSelection,
  endDateSelection,
  setEndDateSelection,
  onFilterClick,
  onExportClick,
  pickerType,
  searchLoading = false,
  downloadLoading = false,
  minDate = null,
  maxDate = null,
  showTime = false,
  autoCorrectStart = true,
  autoCorrectEnd = true,
  maxDays = null,
}) {
  const disabledStartDate = (current) => {
    if (maxDays && endDateSelection) {
      const earliest = endDateSelection.clone().subtract(maxDays - 1, "days").startOf("day");
      if (current < earliest) return true;
    }
    return false;
  };

  const disabledEndDate = (current) => {
    if (!startDateSelection) return false;
    if (maxDays) {
      const latest = startDateSelection.clone().add(maxDays - 1, "days").endOf("day");
      return current < startDateSelection.clone().startOf("day") || current > latest;
    }
    return current < startDateSelection.clone().startOf("day");
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      <span>Start Date</span>
      <DatePicker
        value={startDateSelection}
        allowClear={false}
        picker={pickerType ? pickerType : "date"}
        onChange={(date) => {
          const startDate = date
            ? pickerType
              ? pickerType === "date"
                ? autoCorrectStart
                  ? date.startOf("day")
                  : date
                : pickerType === "month"
                  ? date.startOf("month")
                  : pickerType === "year"
                    ? date.startOf("year")
                    : date.startOf("day")
              : date.startOf("day")
            : null;
          setStartDateSelection(startDate);
        }}
        minDate={minDate}
        maxDate={maxDate}
        disabledDate={maxDays ? disabledStartDate : undefined}
        showTime={showTime}
      />
      <span>End Date</span>
      <DatePicker
        value={endDateSelection}
        allowClear={false}
        picker={pickerType ? pickerType : "date"}
        onChange={(date) => {
          const endDate = date
            ? pickerType
              ? pickerType === "date"
                ? autoCorrectEnd
                  ? date.endOf("day")
                  : date
                : pickerType === "month"
                  ? date.endOf("month")
                  : pickerType === "year"
                    ? date.endOf("year")
                    : date.endOf("day")
              : date.endOf("day")
            : null;
          setEndDateSelection(endDate);
        }}
        minDate={minDate}
        maxDate={maxDate}
        disabledDate={disabledEndDate}
        showTime={showTime}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "10px",
        }}
      >
        <Button
          icon={<SearchOutlined />}
          onClick={onFilterClick}
          disabled={searchLoading}
        />
        {onExportClick ? (
          <Button
            icon={downloadLoading ? <LoadingOutlined /> : <DownloadOutlined />}
            onClick={onExportClick}
            disabled={searchLoading || downloadLoading}
          />
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}

export function HorizontalDateFilter({
  startDateSelection,
  setStartDateSelection,
  endDateSelection,
  setEndDateSelection,
  onFilterClick,
  onExportClick,
  title,
  minDate = null,
  maxDate = null,
}) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        gap: "5px",
        alignItems: "center",
      }}
    >
      <span>{title ? title : "Date : "}</span>
      <DatePicker.RangePicker
        format="YYYY-MM-DD"
        value={[startDateSelection, endDateSelection]}
        allowClear={false}
        picker="date"
        onChange={(dates, _) => {
          setStartDateSelection(dates[0]);
          setEndDateSelection(dates[1]);
        }}
        minDate={minDate}
        maxDate={maxDate}
      />
      <Button icon={<SearchOutlined />} onClick={onFilterClick} />
      {onExportClick ? (
        <Button icon={<DownloadOutlined />} onClick={onExportClick} />
      ) : (
        <></>
      )}
    </div>
  );
}

export function HorizontalDateMonthYearFilter({
  startDateSelection,
  setStartDateSelection,
  onFilter,
  onExportClick,
  pickerType,
  showTitle = true,
  minDate = null,
  maxDate = null,
  disabled = false,
}) {
  let hasPicker = false;
  if (["date", "month", "year"].includes(pickerType)) {
    hasPicker = true;
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        gap: "5px",
        alignItems: "center",
      }}
    >
      {showTitle ? (
        <span>{pickerType.charAt(0).toUpperCase() + pickerType.slice(1)} </span>
      ) : (
        <></>
      )}

      <DatePicker
        value={startDateSelection}
        allowClear={false}
        picker={pickerType}
        onChange={(date, _) => {
          setStartDateSelection(date);
          onFilter(date);
        }}
        minDate={minDate}
        maxDate={maxDate}
        disabled={disabled}
      />
      {onExportClick ? (
        <Button icon={<DownloadOutlined />} onClick={onExportClick} />
      ) : (
        <></>
      )}
    </div>
  );
}
